import { formatUsd } from "./usageFormat";

// Where one week's spend went: Gemini and GPT, input and output - the four
// amounts the backend keeps (breakdown_usd). A table rather than a chart: four
// numbers, usually fractions of a cent, read better as numbers.
export default function SpendBreakdown({
  breakdown,
  title,
  language,
  formatMoney = formatUsd,
}) {
  const zh = language === "zh";
  const rows = [
    {
      name: "Gemini",
      input: breakdown.gemini_input,
      output: breakdown.gemini_output,
    },
    { name: "GPT", input: breakdown.gpt_input, output: breakdown.gpt_output },
  ];
  const cell = "py-2 pl-2 text-right tabular-nums whitespace-nowrap";

  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-700 p-4 flex flex-col gap-3">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
        {title}
      </h3>
      <div className="min-w-0 overflow-x-auto">
        <table className="w-full text-sm text-gray-700 dark:text-gray-200">
          <thead>
            <tr className="text-xs text-gray-500 dark:text-gray-400">
              <th className="pb-1 text-left font-medium" />
              <th className="pb-1 text-right font-medium">
                {zh ? "輸入" : "Input"}
              </th>
              <th className="pb-1 text-right font-medium">
                {zh ? "輸出" : "Output"}
              </th>
              <th className="pb-1 text-right font-medium">
                {zh ? "小計" : "Total"}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
            {rows.map((row) => (
              <tr key={row.name}>
                <td className="py-2 font-medium">{row.name}</td>
                <td className={cell}>{formatMoney(row.input)}</td>
                <td className={cell}>{formatMoney(row.output)}</td>
                <td className={`${cell} font-semibold`}>
                  {formatMoney(row.input + row.output)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        {zh
          ? "網路搜尋、Google 搜尋接地與嵌入向量的費用計入輸入。"
          : "Web search, Google Search grounding and embeddings count as input."}
      </p>
    </section>
  );
}
